export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const email = 'a.zelcs@andersenlab.com';

export const meetupDate = '2025-06-18';
export const meetupTime = '17:30 GMT+1';
